import { Injectable, inject } from "@angular/core";
import { MsalBroadcastService, MsalService } from "@azure/msal-angular";
import { InteractionStatus } from "@azure/msal-browser";
import { filter, first, startWith, take } from "rxjs";

@Injectable({ providedIn: 'root' })
export class AppInitService {
  private auth = inject(MsalService);
  private msalBroadcast = inject(MsalBroadcastService);

    init(): Promise<void> {
        return new Promise((resolve) => {
            this.auth.instance.handleRedirectPromise().then(() => {

            this.msalBroadcast.inProgress$
                .pipe(
                    startWith(InteractionStatus.None), // força valor inicial
                    filter(status => status === InteractionStatus.None),
                    take(1)
                )
                    .subscribe(() => {
                    const account = this.auth.instance.getAllAccounts()[0];
                    if (!account) {
                        this.auth.instance.loginRedirect();
                        return;
                    }

                    const claims = account.idTokenClaims as any;
                    const roles: string[] = [];
                    const markets: string[] = [];

                    claims.roles?.forEach((mkt: string) => {
                        if (mkt.includes("MARKET")) {
                            markets.push(mkt);
                        } else {
                            roles.push(mkt);
                        }
                    });

                    sessionStorage.setItem("rtm-cpm-user", JSON.stringify({
                        name: account.name,
                        email: account.username,
                        roles,
                        markets
                    }));

                    resolve(); 
                });
            });
        });
    }

}

export function initializeApp(appInitService: AppInitService) {
    return () => appInitService.init();
}